import React from 'react';
import './VersionHistory.css';

const VersionHistory: React.FC = () => {
  return (
    <div className="version-history-container">
      <h1>Versjonshistorikk</h1>

      <section className="version-section">
        <h2>v0.3.0 - Januar 2026</h2>
        <p className="version-date"><strong>Lansert:</strong> 16. januar 2026</p>

        <h3>Nye funksjoner</h3>
        <ul>
          <li>Komplett automatisering av Sykkelfester fra planlegging til avslutning</li>
          <li>E-postverifisering påkrevd for å motta varsler om arrangementer. Alle meldinger også tilgjengelig inne på Sykkelfest portalen.</li>
        </ul>

        <h3>Forbedringer</h3>
        <ul>
          <li>Vertsvarslinger inneholder nå mer detaljert informasjon om sykkelfesten, gjester og måltid</li>
          <li>Tydelig varsling for uverifiserte e-postadresser på Mine Fester og profilside</li>
          <li>Logg-visningen skiller mellom uverifiserte adresser og faktiske feil</li>
          <li>Bedre håndtering av par hvor bare én partner har verifisert e-post</li>
        </ul>
      </section>

      <section className="version-section">
        <h2>v0.2.4 - Januar 2026</h2>
        <p className="version-date"><strong>Lansert:</strong> 11. januar 2026</p>

        <h3>Forbedringer</h3>
        <ul>
          <li>Brukergrensesnitt forbedret for å sikre bedre informasjon, brukerflyt og opplevelse på tvers av plattformer</li>
          <li>Arrangørverktøy utvidet for å gi ressurser og informasjon nødvendig for å organisere og dele info om Sykkelfester</li>
          <li>Sikkerhets- og ytelsesoptimaliseringer for raskere og mer pålitelig pålogging</li>
        </ul>
      </section>

      <section className="version-section">
        <h2>v0.2.3 - Januar 2026</h2>
        <p className="version-date"><strong>Lansert:</strong> 10. januar 2026</p>

        <h3>Nye funksjoner</h3>
        <ul>
          <li>Systeminnstillinger for plattformadministrasjon med standardverdier for arrangementer og arrangører</li>
          <li>Logg-visning for administratorer med full oversikt over systemhendelser og e-postkommunikasjon</li>
          <li>Forbedret visning av kartfunksjoner med bedre lesbarhet</li>
        </ul>

        <h3>Forbedringer</h3>
        <ul>
          <li>Standardverdier fra systeminnstillinger brukes ved opprettelse av nye arrangementer</li>
          <li>Bedre håndtering av manglende verdier i arrangøradministrasjon</li>
        </ul>
      </section>

      <section className="version-section">
        <h2>v0.2.2 - Januar 2026</h2>
        <p className="version-date"><strong>Lansert:</strong> 9. januar 2026</p>

        <h3>Nye funksjoner</h3>
        <ul>
          <li>Faktureringssystem for administratorer med oversikt over alle arrangementer</li>
          <li>Statistikk for kostholdsrestriksjoner i arrangementsoversikten</li>
          <li>Betalingsbetingelser (netto dager) for arrangører</li>
        </ul>

        <h3>Forbedringer</h3>
        <ul>
          <li>Kompakt tabellvisning i arrangøradministrasjon</li>
          <li>Forbedret varslingssystem med native notifikasjoner</li>
          <li>Bedre strukturert visning av arrangørinnstillinger</li>
        </ul>
      </section>

      <section className="version-section">
        <h2>v0.2.1 - Januar 2026</h2>
        <p className="version-date"><strong>Lansert:</strong> 8. januar 2026</p>

        <h3>Nye funksjoner</h3>
        <ul>
          <li>Komplett søknadssystem for å bli arrangør</li>
          <li>E-postverifisering for arrangørsøknader</li>
          <li>Administrasjonspanel for godkjenning av arrangører</li>
          <li>Loggføring av arrangørsøknader og godkjenninger</li>
        </ul>

        <h3>Forbedringer</h3>
        <ul>
          <li>Forbedret profilside for deltakere</li>
          <li>Bedre navigasjon mellom ulike brukerroller</li>
          <li>Mer informative e-postmeldinger med bedre design</li>
        </ul>
      </section>

      <section className="version-section">
        <h2>v0.2.0 - Desember 2025</h2>
        <p className="version-date"><strong>Lansert:</strong> 31. desember 2025</p>

        <h3>Nye funksjoner</h3>
        <ul>
          <li>Grunnleggende plattform for arrangement av sykkelselskap</li>
          <li>Påmelding og profiler for deltakere</li>
          <li>Arrangørstyring for opprettelse av arrangementer</li>
          <li>Automatisk rute- og gruppeberegning</li>
          <li>E-postvarsling ved viktige hendelser</li>
          <li>Interaktive kart med Azure Maps</li>
          <li>Admin-dashboard for brukerstyring</li>
        </ul>

        <h3>Tekniske forbedringer</h3>
        <ul>
          <li>Sikker autentisering</li>
          <li>Geografisk søk etter arrangementer</li>
          <li>Responsive design for mobil og desktop</li>
        </ul>
      </section>

      <section className="version-section">
        <h2>v0.1.0 - Desember 2025</h2>
        <p className="version-date"><strong>Lansert:</strong> 26. desember 2025</p>

        <h3>Første versjon</h3>
        <ul>
          <li>Grunnleggende infrastruktur og prosjektoppsett</li>
          <li>Innloggings- og registreringssystem</li>
          <li>Landingsside med informasjon om plattformen</li>
          <li>FAQ, Personvern, og Vilkår-sider</li>
          <li>Domenet sykkelfest.no</li>
        </ul>
      </section>
    </div>
  );
};

export default VersionHistory;
